import Button from '@gaia/components/Button';
import type {DefaultSources, HuntingStates} from '@gaia/utils/gaia/fetchDefaultUserLayers';
import {FormControl, InputLabel, NativeSelect, Typography} from '@mui/material';
import {useState} from 'react';

interface HuntingMapsProps {
    huntingStates: HuntingStates[];
    setDisplayedLayerList: SetState<string[]>;
    layerDefaults: DefaultSources | undefined;
}
export default function HuntingMaps({
    huntingStates,
    setDisplayedLayerList,
    layerDefaults,
}: HuntingMapsProps) {
    const [selectedState, setSelectedState] = useState('');

    function onChange(event: React.ChangeEvent<HTMLSelectElement>) {
        const selection = event.target.value;
        setSelectedState(selection);
        const stateSelected = huntingStates.find((state) => state.state === selection)?.sources;
        if (stateSelected) {
            setDisplayedLayerList(stateSelected);
        }
    }
    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'baseline',
                justifyContent: 'space-around',
            }}
        >
            <Typography variant='body1'>Find Hunting Units (US and Canada):</Typography>
            <FormControl variant='standard'>
                <InputLabel htmlFor='age-native-helper'>State</InputLabel>
                <NativeSelect value={selectedState} onChange={(event) => onChange(event)}>
                    <option aria-label='None' value='' />
                    {huntingStates.map((state) => (
                        <option key={state.state + (state.country ?? '')} value={state.state}>
                            {state.state}
                        </option>
                    ))}
                </NativeSelect>
            </FormControl>
            {selectedState && (
                <Button
                    appearance='secondary'
                    size='small'
                    onClick={() => {
                        setSelectedState('');
                        if (layerDefaults?.sources) {
                            setDisplayedLayerList(layerDefaults?.sources);
                        }
                    }}
                >
                    Clear
                </Button>
            )}
        </div>
    );
}
